import { v4 as uuid } from 'uuid'
import { IDelivery, ILineItem } from '../../cart/ICart'

const validateAddress = (address?: any) => {
    return !!(address?.address1 && address.city && address.state && address.zip)
}

export function buildPhysicalDeliveries(
    existingDeliveries: IDelivery[],
    isMultipleShipments: boolean
) {
    const newDeliveries: IDelivery[] = []

    if (!isMultipleShipments) {
        // collect all line items to place in single shipment
        const lineItems: ILineItem[] = []
        let totalPrice: number = 0
        existingDeliveries.forEach((delivery) => {
            lineItems.push(...delivery.line_items)
            totalPrice += Number(delivery.resolved_data.total_price)
        })

        const delivery_details = existingDeliveries[0]?.delivery_details
        const delivery_option = existingDeliveries[0]?.delivery_option
        const resolved_data = existingDeliveries[0]?.resolved_data

        newDeliveries.push({
            delivery_uuid: uuid(),
            delivery_details: delivery_details,
            delivery_option: delivery_option,
            line_items: lineItems,
            resolved_data: {
                items_count: lineItems.length,
                delivery_price: 0,
                delivery_options: resolved_data?.delivery_options,
                total_price: totalPrice,
            },
        })

        return newDeliveries
    }

    existingDeliveries?.forEach((delivery) => {
        const { delivery_option, delivery_details, resolved_data } = delivery
        let deliveryDetails = delivery_details
        let deliveryOption = delivery_option

        if (!delivery_details?.address) {
            deliveryDetails = {
                ...deliveryDetails,
                address: {
                    name: '',
                    address1: '',
                    address2: '',
                    city: '',
                    state: '',
                    zip: '',
                },
            }
        }

        if (!validateAddress(deliveryDetails.address)) {
            deliveryOption = {
                ...deliveryOption,
                delivery_option_uuid: '',
            }
        }

        // if the delivery has a single item, keep it as is
        if (delivery.resolved_data.items_count === 1) {
            newDeliveries.push({ ...delivery, delivery_option: deliveryOption })
            return
        }
        // if the delivery has more than one item in it
        delivery.line_items.forEach((lineItem: any) => {
            // check if it's a box
            // if it isn't, put it in a new delivery
            if (!lineItem?.customization_data?.box_uuid) {
                newDeliveries.push({
                    delivery_uuid: uuid(),
                    delivery_details: deliveryDetails,
                    delivery_option: deliveryOption,
                    line_items: [lineItem],
                    resolved_data: {
                        items_count: 1,
                        delivery_price: 0,
                        delivery_options: resolved_data.delivery_options,
                        total_price:
                            Number(lineItem.resolved_data.fees_total) +
                            Number(lineItem.resolved_data.item_price),
                    },
                })
                return
            }
            // if it is a box, check if there is an existing box for it
            const existingBox = newDeliveries.find((delivery) => {
                return delivery.line_items.find(
                    (item: any) =>
                        item.customization_data?.box_uuid ===
                        lineItem.customization_data?.box_uuid
                )
            })
            if (!!existingBox) {
                existingBox.line_items.push(lineItem)
                existingBox.resolved_data.items_count += 1
                return
            }
            // if not, put it in a new delivery
            newDeliveries.push({
                delivery_uuid: uuid(),
                delivery_details: deliveryDetails,
                delivery_option: deliveryOption,
                line_items: [lineItem],
                resolved_data: {
                    items_count: 1,
                    delivery_price: 0,
                    delivery_options: resolved_data.delivery_options,
                },
            })
        })
    })
    return newDeliveries
}
